<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <JobsToday />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <ServiceVolumeGraph />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <KpiMachine />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <KpiCustomer />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <ServiceVolumeGraphCompareLastYear />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6">
                <SupplierFailureCodeGraph v-if="false" />
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import JobsToday from "@/views/dashboard/JobsTodayStatistics.vue";
import KpiCustomer from "@/views/dashboard/KpiCustomer.vue";
import KpiMachine from "@/views/dashboard/KpiMachine.vue";
import ServiceVolumeGraph from "@/views/dashboard/ServiceVolumeGraph.vue";
import ServiceVolumeGraphCompareLastYear from "@/views/dashboard/ServiceVolumeGraphCompareLastYear.vue";
import SupplierFailureCodeGraph from "@/views/dashboard/SupplierFailureCodeGraph.vue";


export default {
  name: "DashboardHome",
  props: [],
  components: {
    ServiceVolumeGraph,
    ServiceVolumeGraphCompareLastYear,
    SupplierFailureCodeGraph,
    KpiMachine,
      KpiCustomer,
    JobsToday
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>
